import axios from 'axios';

export const swrFetcher = async (url: string) => (await axios.get(url)).data;
